export const APP_CONFIG_LOCAL_STORE = {
    APP_LANGUAGE : "E9_APP_LANG",
    APP_COUNTRY : "E9_APP_COUNT",
    APP_THEME : "E9_APP_THEME",
    ALL_LANGUAGES : "ALL_LANGUAGES"
}